<div class="modal-header">
  <h2 mat-dialog-title class="modal-title synchpc-primary">Confirmation</h2>

</div>
<div class="modal-body text-grey">
  <mat-dialog-content>
    Are you sure you want to update the existing job template?
  </mat-dialog-content>
</div>

<div class="modal-footer">
  <mat-dialog-actions>
    <button mat-button class="btn btn-primary ms-2" [mat-dialog-close]="true">Yes</button>
    <button mat-button class="btn btn-outline-secondary" [mat-dialog-close]="false">No</button>
  </mat-dialog-actions>
</div>

